import { Module } from 'vuex';
import { IRootState, IPopupState } from '@types';

const store: Module<IPopupState, IRootState> = {
    state: {
        popupObservers: [],
    },

    mutations: {
        addPopupObserver(state, o) {
            state.popupObservers.push(o);
        },

        removePopupObserver(state, o) {
            state.popupObservers = state.popupObservers.filter((i) => i != o);
        },

        openPopup(state, name: string) {
            for (let popup of state.popupObservers) {
                if (popup.name === name) return popup.$emit('open');
            }
        },

        closeAllPopups(state) {
            for (let popup of state.popupObservers) {
                popup.$emit('close');
            }
        },
    },

    getters: {
        getIsAnyPopupVisible(state) {
            for (let popup of state.popupObservers) {
                if (popup.getIsVisible === true) return true;
            }
            return false;
        },
    },

    actions: {
        addPopupObserver({ commit }, o) {
            commit('addPopupObserver', o);
        },

        removePopupObserver({ commit }, o) {
            commit('removePopupObserver', o);
        },

        closeAllPopups({ commit }) {
            commit('closeAllPopups');
        },
    },
};

export default store;
